import React, { useEffect, useState, useContext, useReducer} from "react";
import { AuthContext } from '../../shared/context/auth-context';
import SearchBox from "../../customer/components/SearchBox";
import { useHttpClient } from "../../shared/hooks/http-hook";
import Table from "../../shared/components/Table/Table";
import { ItemTableHeaders, ItemPrintTableHeaders, ItemMobileTableHeaders } from "../components/ItemTableHeaders";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import "./Items.css";
import Scroll from "../../shared/components/navigation/Scroll";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import "tachyons";
import Button from "../../shared/components/formElements/Button";
import { useWindow } from '../../shared/hooks/window-hook';

export const reducer = (state, action) => {

  switch (action.type){
      case "CHANGE_INPUT":

          return{
              ...state,
              [action.payload.name]:action.payload.value
          };
      default:
          return state;
  }
}

const initialState = {
  initial : false,
};

const Items = () => {
  const { width } = useWindow();
  const [dropDownValue, setDropDownValue]  = useState("INVENTORY");
  const [state, dispatch] = useReducer(reducer, initialState);
  const [printstate, setPrintstate] = useState(true);
  
  const handleChange = (e) => {
    let value = true
    if (state[e.target.id]){
      value = false
    }
    dispatch({
      type: "CHANGE_INPUT",
      payload: { name: e.target.id, value },
    });
  };

  const entries = Object.entries(state);
  let finalState = entries.filter(entry => entry[1]).map(entry=>entry[0])


  const auth = useContext(AuthContext);
  const [items, setItems] = useState([]);
  const [searchfield, setSearchfield] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  useEffect(() => {
    const fetchItems = async () => {
      let responseData;
      try {
        responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+"/items",
        "GET",
        null,
        {Authorization: 'Bearer '+ auth.token});
        setItems(responseData.items);
      } catch (err) { }
    };
    fetchItems();
  }, [sendRequest, auth.token]);

  
  const filteredItems = items.filter((item) => {
    return (
      item.style.toLowerCase().includes(searchfield.toLowerCase()) ||
      item.company.toLowerCase().includes(searchfield.toLowerCase()) ||
      item.color.toLowerCase().includes(searchfield.toLowerCase()) ||
      item.USSize.toLowerCase().includes(searchfield.toLowerCase()) ||
      item.EURSize.toLowerCase().includes(searchfield.toLowerCase()) ||
      String(item.quantity).includes(searchfield) ||
      String(item.cost).includes(searchfield)||
      String(item.price).includes(searchfield)
      );
    }).map((item) =>{

      return( {
        ...item,
        style: item.style.split('_')[0],
        type: item.type === "regular" ? "" : item.type,
        select: <input 
                  id={item.style} 
                  type="checkbox" 
                  checked={!state.hasOwnProperty(item.style) ? state.initial : state[item.style]}
                  onChange={handleChange}
                  className="inventory-box-size"
                />

    })
    }).reverse();


    const soldItems = filteredItems.filter((item) => item.quantity === 0 )
    const inventoryItems = filteredItems.filter((item) => item.quantity > 0 )
    const dropdownChangeHandler = (event) => {
      setDropDownValue(event.target.value);
    }
  

  const onSearchChange = (event) => {
    setSearchfield(event.target.value);
  };

  const printObject = items.filter(item => finalState.includes(item.style) )
 
  const printHandler = () => {
    if(printObject.length > 0) {
      setPrintstate(!printstate)
      !printstate && window.print();
      setSearchfield("")

    } else {
      window.print();
      setSearchfield("")
    }
  }

  
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />

<div className="flex">
  <div className={width > 800 ? " w-33 pa3": " w-333"}>
    <div className={width > 800 ? "show-checkbox" : ""}>
    <label>
      <select onChange={dropdownChangeHandler} defaultValue={'INVENTORY'} className="pa2 bg-light-gray br3">
      <option value="INVENTORY" >INVENTORY </option>
      <option key={"ARCHIVE"} value="ARCHIVE">ARCHIVE</option>       
      </select>
    </label>
   </div>
  </div>
  
  <div className=" w-33  mr2">
    {printstate && <div className="tc">
      <div style={{ display: "inline-block" }}>
        <SearchBox searchChange={onSearchChange} />
      </div>
    </div>}
  
  </div>
  <div className="w-33 tr mr5">
    {width > 800 ? 
 
      <Button inverse 
        onClick={printHandler}>                
        {printstate ? "PRINT" : "🖨️"}
    </Button> : ""}
  </div>
</div>

      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
        {width < 800 ? 
 
 <Button inverse 
   onClick={printHandler}>                
   {printstate ? "PRINT" : "🖨️"}
</Button> : "" }

        {!isLoading && filteredItems && printstate && (
          <div className="page">

            <Table headers={width > 800 ? ItemTableHeaders : ItemMobileTableHeaders} content={dropDownValue==="INVENTORY" ? inventoryItems : soldItems} />
          </div>
        )}
         {!printstate && <Scroll><Table headers={ItemPrintTableHeaders} content={printObject} /></Scroll>}
  
      {printstate && <FloatingButton route={"/items/new"} />}
    </React.Fragment>
  );
};

export default Items;